/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PuffLoader from 'react-spinners/PuffLoader';

import api from 'api';

import {
  fetchQlikToken,
  generateQtoken,
  getWrapperObj,
} from 'store/auth/auth-actions';
import {
  setComponentAccessList,
  setFavReportObj,
  setRestrictedEcosystem,
  setRestrictedProductSquad,
  setRoles,
  setToken,
  setUserClaimObject,
  setUserRestriction,
  setWrapperObj,
} from 'store/auth/Authslice';
import {
  getAdvanceSearchFieldsData,
  getTableRestrictions,
} from 'store/customer/customer-view-actions';
import { setDefaultCustomerType } from 'store/customer/customerViewSlice';
import {
  getFavoriteData,
  getSystemAlertsData,
} from 'store/home/home-my-view-actions';
import { setSystemAlertsData } from 'store/home/homeMyViewSlice';
import { isTokenExpired } from '../../utils/token-expired';

const AuthenticateUser = () => {
  const [searchParams] = useSearchParams();
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const loading = useRef(true);

  const getSystemAlerts = async (role) => {
    let data = await getSystemAlertsData(role);
    dispatch(setSystemAlertsData(data));
    data?.length ? navigation('/system-alerts') : navigation('/home');
  };

  const favoritesData = async (unixId, roleId) => {
    let favData = await getFavoriteData(unixId, roleId);
    dispatch(setFavReportObj(favData));
  };

  useEffect(() => {
    if (isTokenExpired(localStorage.getItem('token'))) {
      dispatch(
        setToken({ accessToken: null, refreshToken: null, isLoading: true })
      );
    }

    if (searchParams.get('code') !== '') {
      api
        .post('authenticate', {
          access_code: searchParams.get('code'),
          redirect_uri: `${process.env.REACT_APP_WEB_HOST}/authenticate`,
        })
        .then((res, err) => {
          localStorage.setItem('token', res.data.token.access_token);
          localStorage.setItem(
            'c360-refresh-token',
            res.data.token.refresh_token
          );

          dispatch(
            setToken({
              accessToken: res.data.token.access_token,
              refreshToken: res.data.token.refresh_token,
              isLoading: false,
            })
          );
          dispatch(setRoles(res.data.roles));

          (async () => {
            await generateQtoken(res.data?.userClaimObject?.unixId);
            if (res.data.roles.length === 1) {
              getWrapperObj(res.data.userClaimObject?.roleId)
                .then((result, err) => {
                  dispatch(setWrapperObj(result));
                })
                .catch((err) => {
                  console.log(err);
                });

              let roleData = res.data.roles[0];
              dispatch(setRestrictedEcosystem(roleData.restrictedEcosystem));
              dispatch(setUserRestriction(roleData.roleRestriction));

              dispatch(setRestrictedProductSquad(roleData.restrictionsDetails));
              dispatch(setUserClaimObject(res.data.userClaimObject));
              dispatch(setComponentAccessList(roleData.componentAccessList));
              dispatch(getTableRestrictions(res.data.userClaimObject?.roleId));
              favoritesData(
                res?.data?.userClaimObject?.unixId,
                res?.data?.userClaimObject?.roleId
              );

              if (process.env.REACT_APP_MAINTENANCE_IN_PROGRESS === 'true') {
                localStorage.clear();
                navigation('/maintenance');
              } else {
                // Removing the settimeout as we are waiting for generating qliktoken now
                if (process.env.REACT_APP_SHOW_NOTIFICATION === 'true') {
                  navigation('/notification');
                } else {
                  getSystemAlerts(res?.data?.userClaimObject?.roleId);
                }
                loading.current = false;
              }
              const params = {
                offset: 0,
                searchText: '',
                field: 'customer-type',
                kpiId: undefined,
                roleId: res.data.userClaimObject?.roleId
                  ? res.data.userClaimObject?.roleId
                  : '',
              };
              getAdvanceSearchFieldsData(params).then((res) => {
                dispatch(
                  setDefaultCustomerType(
                    res.data.map((i) => {
                      return i.value;
                    })
                  )
                );
              });
            } else {
              let userClaimObject = res.data.userClaimObject;
              userClaimObject = { ...userClaimObject, roleId: '' };
              dispatch(setUserClaimObject(userClaimObject));
              navigation('/roleSelection');
            }
          })();
        })
        .catch((err) => {
          localStorage.clear();
          console.log(err);
          if (err?.response?.data?.Message === 'Invalid access') {
            navigation('/unauthorized');
          } else if (process.env.REACT_APP_MAINTENANCE_IN_PROGRESS === 'true') {
            navigation('/maintenance');
          }
        });
    }
  }, []);

  return (
    <div className='spinner center-page animate__animated animate__fadeIn'>
      <PuffLoader
        color='#004677'
        size={60}
        loading={loading}
      />
      <i className='icon icon__logo animate__animated animate__rubberBand'></i>
    </div>
  );
};
export default AuthenticateUser;
